const actions = {
  async list(context, payload) {
    try {
      const response = await this.$api.call("bank.list", payload);
      const responseData = response.data;

      context.commit("mutationBanks", responseData);

      return response;
    } catch (error) {
      context.commit("mutationBanks", []);
      throw error;
    }
  },

  async detail(context, payload) {
    try {
      const response = await this.$api.call("bank.detail", payload);
      const responseData = response.data;

      context.commit("mutationBanks", responseData);

      return response;
    } catch (error) {
      context.commit("mutationBanks", []);
      throw error;
    }
  },

  async checkAccountNumber(context, payload) {
    try {
      const response = await this.$api.call("bank.checkAccountNumber", payload);
      const responseData = response.data;

      context.commit("mutationCheckAccountNumber", responseData);

      return response;
    } catch (error) {
      context.commit("mutationCheckAccountNumber", []);
      throw error;
    }
  },
};

export default actions;
